import * as React from 'react';
export interface IMessageProps {
    autoClose: boolean;
    text: string;
    value?: string;
    type: string;
    onClose: () => void;
}

interface IMessageState {
    value?: string;
    text: string;
}

export default class Message extends React.Component<
    IMessageProps,
    IMessageState
> {
    private timer: number = 0;
    constructor(props: IMessageProps) {
        super(props);

        this.state = {
            text: props.text,
            value: props.value
        };

        this.startTimer();
    }

    startTimer() {
        clearInterval(this.timer);
        if (
            this.props.autoClose !== undefined &&
            this.props.autoClose === true
        ) {
            this.timer = setInterval(this.onClick.bind(this), 4000);
        }
    }

    componentWillReceiveProps(nextProps: IMessageProps) {
        this.startTimer();
        this.setState({
            text: nextProps.text,
            value: nextProps.value
        });
    }

    onClick() {
        clearInterval(this.timer);
        this.props.onClose();
    }

    render() {
        let text = this.state.text;

        if (this.state.value !== undefined) {
            text = text.replace('%s', this.state.value);
        }

        return (
            <div
                className={'message ' + this.props.type}
                onClick={() => this.onClick()}
            >
                <i className="icon" />
                <span>{text}</span>
            </div>
        );
    }
}

export const getExpirateMessage = () => {
    let t = new Date();
    t.setSeconds(t.getSeconds() + 5);
    return t;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Message.tsx